import { render, staticRenderFns } from "./Osa006.vue?vue&type=template&id=fb76aff0&scoped=true"
var script = {}
import style0 from "./Osa006.vue?vue&type=style&index=0&id=fb76aff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb76aff0",
  null
  
)

export default component.exports